/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Directory company card label and description resolution helpers.
 * @module utils/directory/companyDisplay
 */

import { getReferencedDataOptionById, truncateText } from "../common.js";

export const getCompanyLocationLabel = (company, states, towns) => {
  const address = company?.direccion || [];
  const commercialAddress = address[1] || {};
  const stateOption = getReferencedDataOptionById(
    states,
    commercialAddress?.estado,
  );
  const townOption = getReferencedDataOptionById(
    towns,
    commercialAddress?.municipio,
  );

  return [townOption?.nombre || "", stateOption?.nombre || ""]
    .filter(Boolean)
    .join(", ");
};

export const getCompanyDescription = (company, language) => {
  if (
    company?.indicePerfilEncontrado === 1 ||
    company?.indicePerfilEncontrado == null
  ) {
    if (typeof company.descripcionDeLaEmpresa === "object") {
      return (
        truncateText(company.descripcionDeLaEmpresa[language]) ||
        company.descripcionDeLaEmpresa.es ||
        ""
      );
    }
    return company.descripcionDeLaEmpresa || "";
  }

  if (company?.indicePerfilEncontrado === 2) {
    const profileDescription =
      company?.perfiles?.[0]?.descripcionDeLaEmpresa;
    if (typeof profileDescription === "object") {
      return (
        truncateText(profileDescription[language]) ||
        profileDescription.es ||
        ""
      );
    }
    return profileDescription || "";
  }

  if (company?.indicePerfilEncontrado === 3) {
    const profileDescription =
      company?.perfiles?.[1]?.descripcionDeLaEmpresa;
    if (typeof profileDescription === "object") {
      return (
        truncateText(profileDescription[language]) ||
        profileDescription.es ||
        ""
      );
    }
    return profileDescription || "";
  }

  return "";
};
